import React from "react";
import styles from "./HoverIconButton.module.css";

function HoverIconButton({ icon, onClick, size = 16, "aria-label": ariaLabel, className, ...props }) {
  const iconNode = React.isValidElement(icon)
    ? React.cloneElement(icon, { width: size, height: size })
    : icon;

  return (
    <button
      type="button"
      className={`${styles.btn}${className ? ` ${className}` : ""}`}
      onClick={onClick}
      aria-label={ariaLabel}
      {...props}
    >
      <span className={styles.icon}>{iconNode}</span>
    </button>
  );
}

HoverIconButton.rowClassName = styles.row;

export default HoverIconButton;
